import { IconGlobe } from '../ui/Icon.tsx'
import { Select } from '../ui/Select.tsx'
import { LANG_LABEL, LANGS, type Lang, setLang, useLang } from './index.ts'

/** A globe and the code on the trigger, full names in the menu: it sits in a crowded bar. */
export function LanguageSwitcher({ id = 'language' }: { id?: string }) {
	const lang = useLang()
	return (
		<Select
			id={id}
			label="Language / Limbă / Язык / Langue / Lingua / Тіл / Idioma / Sprache"
			value={lang}
			onValueChange={(v) => setLang(v as Lang)}
			options={LANGS.map((l) => ({ value: l, label: LANG_LABEL[l] }))}
			valueLabel={
				<span className="flex items-center gap-1.5">
					<IconGlobe className="size-[1.125rem] text-ink-2" />
					{/* Under 360px the globe stands alone; the code stays for screen readers. */}
					<span className="max-xs:sr-only">{lang.toUpperCase()}</span>
				</span>
			}
			className="h-9 w-auto gap-1 border-transparent bg-transparent px-2.5 max-sm:px-2 text-[0.875rem] font-[560] hover:border-transparent hover:bg-teal-50 data-[state=open]:border-transparent data-[state=open]:bg-teal-50 focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-700"
		/>
	)
}
